import {Injectable} from '@angular/core';
import {IRecuperationListeDonneesRequete} from '@app/core/interfaces/actions/i-recuperation-liste-donnees-requete';
import {Observable} from 'rxjs';
import {Autowired} from '@angular-ru/autowired';
import {SgiRestService} from '@app/core/services/sgi/sgi-rest.service';
import {WebUtilities} from '@app/core/utilities/web.utilities';
import {API_MOTIF_REJET_DETAILS_PRISE_EN_CHARGE} from '@app/core/constantes';

@Injectable({providedIn: 'root'})
export class MotifRejetTableListeRestApiService implements IRecuperationListeDonneesRequete {
  @Autowired() restService: SgiRestService;

  postArgsMute = {successMute: true, errorMute: false, headers: null, params: null};

  requeteRecuperationListeDonnees(data: any, args?: any): Observable<any> | Promise<any> | any {
    // console.log('data : ', data);
    // console.log('args : ', args);

      // update du paramètre
      data.SortOrder = null;

    const { currentDataUser } = args;

    const sendData = {...data, itemToSearch: {
        ...data.itemToSearch,
        idDemandePriseEnCharge: currentDataUser.idDemandePriseEnCharge,
        InfoSearchidDemandePriseEnCharge: { Consider: true },
    }};

    return this.restService.postRequest(`${WebUtilities.baseUrlApi()}${API_MOTIF_REJET_DETAILS_PRISE_EN_CHARGE}`, sendData, {...this.postArgsMute});
  }
}
